import React, { useState } from "react";
import copyIcon from "../../content/images/copy-icon.svg";
import copiedIcon from "../../content/images/copied-icon.svg";
import { formserverBaseURL, copyToClipboard } from "../../utilities";
import "./copy-to-clipboard.scss";

const CopyToClipboard = ({ text = "", onCopy = null }) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = () => {
    if (typeof onCopy === "function") {
      onCopy();
    } else {
      copyToClipboard(text);
    }
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), 500);
  };

  return (
    <div className="copy-to-clipboard-wrapper">
      <img
        onClick={handleCopy}
        alt="Copy to clipboard"
        title="Copy to clipboard"
        className={`copy-to-clipboard ${
          isCopied ? "copy-to-clipboard__active" : ""
        }`}
        src={formserverBaseURL + `${isCopied ? copiedIcon : copyIcon}`}
      />
    </div>
  );
};

export default CopyToClipboard;
